module.exports = __webpack_public_path__ + "assets/ojoBlanco.7b734dcc33a63de5b34ce3a9c3a6ab16.png";


//////////////////
// WEBPACK FOOTER
// ./img/landingPage/ojoBlanco.png
// module id = 886
// module chunks = 0